import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = null;

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (_, { payload: { furniture = null } }) =>
      furniture,
  },
  initialState,
);

export const getFurnitureFilter = state => state;
